import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Input } from '@components/Input';
import { useCopyToClipboard, useThrottle, useTranslation } from '@hooks';

const PublicLinkField = ({ url }) => {
    const { t } = useTranslation();
    const { onCopy } = useCopyToClipboard();
    const [onCopyClick] = useThrottle(value => onCopy(value), 1000);

    return (
        <Input
            inputProps={{ value: url }}
            label={t('common.publicLink')}
            fullWidth
            onAddonClick={() => onCopyClick(url)}
            addonComponent={<ContentCopyIcon sx={{ fontSize: 18, color: 'var(--text-secondary)' }} />}
            sx={{ marginBottom: '8px', '& .MuiOutlinedInput-root': { backgroundColor: '#fff' } }}
            disabled
        />
    );
};

export default PublicLinkField;
